import type { IncomeStatementId } from "@inrev/common";
import type { StatementMatrixViewModel } from "../../ui/FinancialDataGrid";
import { mergeStatementWithEdits } from "./mergeStatementWithEdits";

export const mergeIncomeStatementWithEdits = (args: {
	viewModel: StatementMatrixViewModel<IncomeStatementId>;
}): StatementMatrixViewModel<IncomeStatementId> =>
	mergeStatementWithEdits({
		...args,
		shouldRollup: (row) => row.allowsAddedLineItems === true,
		rollupLiveChildren: (row) => (row.children ?? []).filter((c) => c.kind === "data"),
		resolveSubtotalChild: (row) => (row.children ?? []).find((c) => c.kind === "subtotal") ?? null,
	});
